module.exports = __webpack_public_path__ + "media/bootstrap-icons/brightness-low-fill-8f4cfa9a.svg";